import React from "react";
const BetInsightsForm = ({
 
  })
export default BetInsightsForm;
